import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => ( {
	gameListcontainer: {
		display             : "grid",
		gridTemplateColumns : "repeat(auto-fit, 150px)",
		gridGap             : "2.5rem",
		margin              : "3rem 2.5rem",
		marginTop           : "calc(2.5rem + 70px) !important",

		[rooterMediaQuery.mobileAndTablet]: {
			justifyContent      : "center",
			gridTemplateColumns : "repeat(auto-fit, 140px)"
		},

		[rooterMediaQuery.mobile]: {
			gridTemplateColumns : "repeat(auto-fit, 75px)",
			marginBottom        : "70px",
			gridGap             : "1.5rem",
			margin              : "3rem 1.5rem"

		}

	},
	title: {
		textTransform : "capitalize",
		margin        : "2rem 2.5rem",
		fontSize      : "2rem",
		fontWeight    : "500"
	},
	titleContainer: {
		top        : "70px",
		width      : "100%",
		height     : "70px",
		zIndex     : 21,
		position   : "fixed",
		background : theme.other.colors.background.secondary
	}
} ), { name: "gamesPage" } );

